// Single source of truth for Andrea's direct contact channels.
// Andrea's verified, text-enabled business number (user-supplied 2026-08-31).
export const ANDREA_PHONE = "+17209263037";
export const ANDREA_PHONE_DISPLAY = "(720) 926-3037";

export const CALENDLY_URL = "https://calendly.com/thenurturedparentcollective/30min";

// True on devices whose primary pointer is touch — where sms:/tel: open the
// native messaging/dialer apps. Desktop browsers get the ContactFallback
// number-and-copy card instead of a dead link.
export const hasNativeContactApps = () =>
  typeof window !== "undefined" &&
  Boolean(window.matchMedia?.("(pointer: coarse)").matches);

export const CONTACT_FALLBACK_EVENT = "andrea-contact-fallback";

// Attach to every sms:/tel: CTA alongside its existing tracking: intercepts
// the click ONLY when no native handler is expected and asks ContactFallback
// to show Andrea's number. kind: "text" | "call". Mobile/native behavior is
// left completely untouched.
export const contactClick = (kind) => (event) => {
  if (hasNativeContactApps()) return;
  event.preventDefault();
  window.dispatchEvent(new CustomEvent(CONTACT_FALLBACK_EVENT, { detail: { kind } }));
};
